<template>
  <div>
    <MessagePopup 
      v-if="show_message" 
      :message="message" 
      :show_message="show_message" 
      @close-message="closeMessage"
      :persistent="!clearable_message"
    ></MessagePopup>
    <FixCIFPopup 
      v-if="show_fix_cif_supplier && currentDocument" 
      :company="supplierdb_selected" 
      :cif_doc="currentDocument.metadata['vat_supplier']" 
      :show="show_fix_cif_supplier" 
      @close="show_fix_cif_supplier=false" 
      @fix="fix_cif_supplier"
    ></FixCIFPopup>
    <FixCIFPopup 
      v-if="show_fix_cif_customer && currentDocument" 
      :company="customerdb_selected" 
      :cif_doc="currentDocument.metadata['vat_customer']" 
      :show="show_fix_cif_customer" 
      @close="show_fix_cif_customer=false" 
      @fix="fix_cif_customer"
    ></FixCIFPopup>
    <v-dialog max-width="1200" v-if="currentDocument"
             v-model="show_invoice_lines_pop_up">
      {{ currentDocument.static_invoice }}
      <v-card style="background-color: white" >
        <InvoiceLinesEditorSimplified
          :invoice_lines="invoice_lines"
          readonly > </InvoiceLinesEditorSimplified>
      </v-card>
    </v-dialog>
    <v-dialog v-if="dialog" v-model="dialog" persistent max-width="500">
      <v-card>
        <v-card-title class="headline"></v-card-title>
        <v-card-text>Se va a eliminar el documento. Está seguro?</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" outlined text class="primary-border" @click="noDeleteItem()">Cancelar</v-btn>
          <v-btn color="white" text class="primary-bckground" @click="deleteItem()">Borrar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-if="simulateDocDialog" v-model="simulateDocDialog" persistent max-width="500">
      <v-card>
        <v-card-title class="headline"></v-card-title>
        <v-card-text>
          <v-autocomplete
            autocomplete="off"
            label="Empresa" 
            v-model="companySimulate"
            :items="get_companydbs"
            item-text="name"
            return-object
            hide-details
          ></v-autocomplete>
          <v-select 
            autocomplete="off" 
            label="Etiquetas" 
            v-model="tagsSimulate" 
            :items="doc_tags_values" 
            item-text="name" 
            item-value="value" 
            :multiple="true"
            clearable
          ></v-select>
          <v-select
            v-model="accounting_date_config"
            label="Fecha contable"
            item-value="id"
            item-text="text"
            :items="ACCOUNTING_DATE_OPTIONS"
          ></v-select>
          <v-text-field v-if="accounting_date_config=='configurated'"
            :class="{red:invalid_default_accounting_date}"
            label="Fecha (dd/mm/YYYY)" v-model="default_accounting_date">
          </v-text-field>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" outlined text class="primary-border" @click="noSimulateItem()">Cancelar</v-btn>
          <v-btn color="white" text class="primary-bckground" @click="simulateItem()" :disabled="!companySimulate">Aceptar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <app-modal-prompt
      v-model="changeCompanyDocDialog"
      :is-confirm-button-disabled="!companyChangeCompany"
      persistent
      @cancel="noChangeCompanyItem()"
      @confirm="changeCompanyItem()"
    >
      <template #title>
        Cambiar Empresa
      </template>
      <app-modal-row>
        <app-modal-col cols="12">
          <app-autocomplete
            autocomplete="off"
            label="Empresa"
            v-model="companyChangeCompany"
            item-text="name"
            return-object
            hide-details
            :items="get_companydbs"
            @change="getCompanyActivityList"
          ></app-autocomplete>
        </app-modal-col>
      </app-modal-row>
      <app-modal-row v-if="companyChangeCompany && showActivityField(companyChangeCompany, 'actividad') && !companyChangeCompany.hide_activities_master">
        <app-modal-col cols="12" class="mt-5">
          <app-select
            v-if="listActividadChangeCompany.length > 0"
            label="Actividad"
            v-model="actividadChangeCompany"
            :items="listActividadChangeCompany"
            item-value="code" 
            item-text="name"
            :clearable="true"
          />
          <app-text-field
            v-else
            kind="number"
            label="Actividad"
            v-model="actividadChangeCompany"
          ></app-text-field>
        </app-modal-col>
      </app-modal-row>
    </app-modal-prompt>

    <v-dialog v-if="addTagsDocDialog" v-model="addTagsDocDialog" persistent max-width="500">
      <v-card>
        <v-card-title class="headline"></v-card-title>
        <v-card-text>
          <v-select 
            autocomplete="off" 
            label="Etiquetas" 
            v-model="tagsAddTags" 
            :items="doc_tags_values" 
            item-text="name" 
            item-value="value" 
            :multiple="true"
            clearable
          ></v-select>
        </v-card-text>  
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" outlined text class="primary-border" @click="noAddTagsItem()">Cancelar</v-btn>
          <v-btn color="white" text class="primary-bckground" @click="addTagsItem()" :disabled="tagsAddTags.length==0">Aceptar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-if="createTrainingDocDialog" v-model="createTrainingDocDialog" persistent max-width="500">
      <v-card>
        <v-card-title class="headline"></v-card-title>
        <v-card-text>
          <v-select 
            autocomplete="off" 
            label="Etiquetas" 
            v-model="tagsTraining" 
            :items="doc_tags_values" 
            item-text="name" 
            item-value="value" 
            :multiple="true"
            clearable
          ></v-select>
        </v-card-text>  
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" outlined text class="primary-border" @click="noTrainingItem()">Cancelar</v-btn>
          <v-btn color="white" text class="primary-bckground" @click="trainingItem()">Aceptar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-if="currentDocument && historyPopup" v-model="historyPopup" max-width="1000"> 
      <v-card>
        <DocumentHistoryComponent :doc_id="currentDocument.id"></DocumentHistoryComponent>
      </v-card> 
    </v-dialog>

    <v-dialog v-if="errorDialog" v-model="errorDialog" max-width="1500">
      <v-card>
        <v-card-title class="headline"></v-card-title>
        <v-card-text>
          <div v-if="invoice_error">
            Factura: <br/>
            {{ invoice_error }}
            <v-divider/>
          </div>
          <div v-if="account_moves_errors.length">
            <div v-for="ame in account_moves_errors" :key="ame.id">
              Asiento {{ame.id}}: <br/>
              {{ame.error}}
              <v-divider/>
            </div>
          </div>
        </v-card-text>  
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="white" text class="primary-bckground" @click="errorDialog=false">Ok</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-if="go_simulation_dialog" v-model="go_simulation_dialog" max-width="1000">
      <v-card>
        <v-card-title class="headline"></v-card-title>
        <v-card-text>
          <v-autocomplete
            autocomplete="off" 
            label="Simulaciones" 
            v-model="simulation_to_go" 
            :items="simulations" 
            item-text="text" 
            return-object
          ></v-autocomplete>
        </v-card-text>  
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" outlined text class="primary-border" @click="go_simulation_dialog=false">Cancelar</v-btn>
          <v-btn color="white" text class="primary-bckground" @click="goToSimulation(simulation_to_go['cdb'], simulation_to_go['id'])">Ir</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-toolbar v-if="inRotationMode" absolute min-width="100%">
      <h1>Rotación de páginas</h1>
    </v-toolbar>
    <v-toolbar absolute min-width="100%" v-else>
      <v-btn
        color="primary"
        :loading="downloading"
        :disabled="isWaitingFlow"
        @click="downloadFile({'signed_url':getFileurl,'filename':getFileName})"
        icon
      >
        <v-icon v-once>mdi-download</v-icon>
      </v-btn>

      <JobProgress v-model="deleteProgressState" :job_id="deleteJobId" v-on:done="deleteItemDone">
        <template v-slot:progress>
          <v-btn loading icon></v-btn>
        </template>
        <template v-slot:quiet>
          <v-btn
            color="primary"
            :loading="deleting || Boolean(deleteJobId)"
            :disabled="isWaitingFlow"
            @click="delete_document()"
            icon
          >
            <v-icon v-once>mdi-delete</v-icon>
          </v-btn>
        </template>
      </JobProgress>
      <v-btn
        v-if="currentDocument && !currentDocument.forced_move"
        color="primary"
        :loading="documentWriting"
        :disabled="true"
        @click="saveLabels()"
        icon
      >
        <!-- :disabled="!canSave()" -->
        <v-icon v-once>mdi-content-save</v-icon>
      </v-btn>
      <v-btn
        v-if="currentDocument && currentDocument.forced_move"
        color="primary"
        :disabled="!canSave()"
        :loading="documentWriting"
        @click="saveDocument()"
        icon
      >
        <v-icon v-once>mdi-content-save</v-icon>    
      </v-btn>
      <!-- <v-btn
        color="primary"
        v-if="showRetry || showContabilize"
        @click="toggleRotationMode()"
        icon
      >
        <v-icon>mdi-rotate-3d-variant</v-icon>
      </v-btn> -->

      <!-- <v-btn
        v-if="got_feature('feature_invoice_lines')"
        color="primary"
        @click="downloadFacturae()"
        icon
      >
        <v-icon>mdi-file-download</v-icon>
      </v-btn> -->
      
      <v-btn
        v-if="got_feature('feature_diezsoftware_nube')"
        color="primary"
        @click="forceSendDocument()"
        icon
      >
        <v-icon>mdi-file-send</v-icon>
      </v-btn>

      <v-menu
        v-if="true || showRetry || showContabilize || (currentDocument && currentDocument.state=='pending_sync' && getActions.some(el => el.id === 'mark_as_pending_review'))"
        v-model="menu"
        :close-on-click="false"
        :close-on-content-click="false"
        offsetY
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            color="primary"
            v-if="true || showRetry || showContabilize || (currentDocument && currentDocument.state=='pending_sync' && getActions.some(el => el.id === 'mark_as_pending_review'))"
            icon
            v-bind="attrs"
            v-on="on"
            :disabled="Boolean(permission.is_readonly)"
          >
            <v-icon v-once>mdi-menu</v-icon>
          </v-btn>
        </template>
        <v-list>
          <v-list-item-group color="primary">
            <div v-for="(action, index) in getActions" :key="index">
               <v-list-item
                v-if="action.id=='force_docs_state_to_done'"
                v-show="currentDocument && currentDocument.state=='error_account_connector'"
                @click="go(action.id)"
                :class="{ list: true}"
              >
                <v-list-item-title class="list-title">{{ action.name }}</v-list-item-title>
              </v-list-item>
              <v-list-item
                v-else-if="action.id=='mark_as_pending_review'"
                v-show="currentDocument && currentDocument.state=='pending_sync'"
                @click="go(action.id)"
                :class="{ list: true}"
              >
                <v-list-item-title class="list-title">{{ action.name }}</v-list-item-title>
              </v-list-item>
              <v-list-item
                v-else
                :disabled="currentDocument && currentDocument.state=='pending_sync'"
                @click="go(action.id)"
                :class="{ list: true}"
              >
              <!-- class="list" -->
                <v-list-item-title class="list-title">{{ action.name }}</v-list-item-title>
              </v-list-item>
            </div>
          </v-list-item-group>
        </v-list>
      </v-menu>
      


      <template v-if="currentDocument">
        <v-btn icon v-if="existsMoreThanOneDocument" :loading="loading_previous" color="primary" :disabled="!canGoToPreviousDocument" @click="previous_document()"><v-icon v-once>mdi-arrow-left</v-icon></v-btn>
        <v-btn icon v-if="existsMoreThanOneDocument" :loading="loading_next" color="primary" :disabled="!canGoToNextDocument" @click="next_document()"><v-icon v-once>mdi-arrow-right</v-icon></v-btn>
        <v-spacer></v-spacer>
        <v-progress-circular 
          v-if="isWaitingFlow && permission.can_write"
          indeterminate
          color="primary"
        ></v-progress-circular>
        <div v-else-if="permission.can_write">
          <v-btn 
            v-if="showRetry && currentDocument.state!='pending_approval'"
            color="primary" 
            :loading="flowLoading" 
            @click="reintentar()" 
            :disabled="isWaitingFlow"
          >Reintentar </v-btn>
          <v-btn 
            v-else-if="currentDocument.state=='company_detected'"
            color="primary" 
            :loading="flowLoading" 
            @click="transfer_to_detected_company()" 
            :disabled="isWaitingFlow"
          >Transferir</v-btn>
          <v-btn 
            v-if="showRetry && currentDocument.state=='pending_approval'"
            color="primary" 
            :loading="flowLoading" 
            @click="reintentar()" 
            :disabled="isWaitingFlow"
          >APROBAR</v-btn>
          <v-btn 
            v-if="showContabilize"
            color="primary" 
            :loading="flowLoading" 
            @click="contabilizar()" 
            :disabled="isWaitingFlow"
          >Contabilizar</v-btn>
        </div>
      </template>
    </v-toolbar>
    <div class="mt-16" v-if="inRotationMode">
      <JobProgress v-model="rotateProgressState" :job_id="rotateJobId" v-on:done="rotateDone" v-on:error="rotateDone">
        <template v-slot:progress>
          <div class="d-flex justify-center pt-10">
            <v-progress-circular indeterminate color="secundary" />
          </div>
        </template>
        <template v-slot:quiet>
          <div class="d-flex justify-center pt-10" v-if="rotateJobId">
            <v-progress-circular indeterminate color="secundary" />
          </div>
          <v-row class="pl-4 pr-4" v-else>
            <v-col cols="12">
              <v-select
                :items="[
                  {text: 'Rotar todos los documentos', value:'all'},
                  {text: 'Rotar por página', value:'page'},
                ]"
                @change="setRotationMode"
                v-model="rotationPageMode"
                label="Modo de rotación"
              >
              </v-select>
            </v-col>
          </v-row>
          <v-row class="pl-4 pr-4">
            <v-col cols="6">
              <v-btn color="primary" outlined @click="cancelRotationMode()">
                Cancelar rotación
              </v-btn>
            </v-col>
            <v-col cols="6">
              <v-btn color="primary" @click="doRotation()">
                Guardar rotación
              </v-btn>
            </v-col>
          </v-row>
        </template>
      </JobProgress>
    </div>
    <div class="mt-16" v-else>
    <v-row v-if="userData.can_debug_documents">
      <v-col cols="3" class="pr-0">
        <v-btn color="primary" @click="changeDrawerMode()"><v-icon v-once>mdi-autorenew</v-icon></v-btn>
      </v-col>
      <v-col cols="6" class="pr-0">
        <v-list-item-title class="title">Modo Cliente</v-list-item-title>
      </v-col>
    </v-row>

    <v-row v-if="showErrorBtn && (invoice_error || account_moves_errors.length) && (userData.is_staff || userData.hasOwnProperty('username') && session_information.hasOwnProperty('username') && (session_information.username != userData.username))">
      <v-col cols="3" class="ml-4">
        <v-btn color="red" @click="errorDialog = true"><v-icon v-once>mdi-alert-decagram</v-icon></v-btn>
      </v-col>
    </v-row>

    <v-row no-gutters class="pt-4 pl-4 pr-4">
      <v-col cols="12" sm="6" v-if="currentDocument">
        <v-autocomplete
            autocomplete="off"
            label="Tipo de documento"
            v-model="document_kind"
            :items="availableDocs"
            item-text="text"
            item-value="id"
            :disabled="!currentDocument || currentDocument.forced_move || isWaitingFlow || ['pending_connect','accounting_aplifisa_fiscal','accounting_invoice','pending_sync','done','done_manually','done_with_warning', 'pending_upload'].includes(currentDocument.state)"
        ></v-autocomplete>
      </v-col>
      <v-col cols="10" sm="5" v-if="showActivityField(currentDocument && currentDocument.companydb_info, 'actividad') && got_feature('feature_actividad_selector') && activitySwitcher.length > 0 && currentCompany && !currentCompany.hide_activities_master">
        <v-autocomplete
          label="Actividad"
          :background-color="activityError"
          v-model="document_actividad"
          :items="activitySwitcher"
          item-value="code" item-text="name"
          :clearable="true"
          :disabled="!currentDocument || isWaitingFlow"
          style="margin-left: 10px;"
        />
      </v-col>
      <v-col cols="10" sm="5" v-else-if="showActivityField(currentDocument && currentDocument.companydb_info, 'actividad') && currentCompany && !currentCompany.hide_activities_master">
        <v-text-field
          style="margin-left: 10px;"
          :background-color="activityError"
          :disabled="!currentDocument || isWaitingFlow"
          v-model="document_actividad"
          :hide-details="true"
          label="Actividad">
        </v-text-field>
      </v-col>
      <v-col cols="10" sm="5" v-else-if="showActivityField(currentDocument && currentDocument.companydb_info, 'actividad_str') && got_feature('feature_actividad_str_field') && got_feature('feature_actividad_selector') && activitySwitcher.length > 0 && currentCompany && !currentCompany.hide_activities_master">
        <v-autocomplete
          label="Actividad"
          v-model="document_actividad_str"
          :items="activitySwitcher"
          item-value="code" item-text="name"
          :clearable="true"
          :disabled="!currentDocument || isWaitingFlow"
          :background-color="activityError"
          style="margin-left: 10px;"
        />
      </v-col>
      <v-col cols="10" sm="5" v-else-if="showActivityField(currentDocument && currentDocument.companydb_info, 'actividad_str') && got_feature('feature_actividad_str_field') && currentCompany && !currentCompany.hide_activities_master">
        <v-text-field
          style="margin-left: 10px;"
          :background-color="activityError"
          :disabled="!currentDocument || isWaitingFlow"
          v-model="document_actividad_str"
          label="Actividad">
        </v-text-field>
      </v-col>
      <v-col cols="10" sm="5" v-if="userData['available_features']['feature_document_projects'] && (currentDocument && currentDocument.companydb_info.companydb_type.params && currentDocument.companydb_info.companydb_type.params.show && currentDocument.companydb_info.companydb_type.params.show.includes('project') && currentCompany && !currentCompany.hide_projects_master)">
        <v-autocomplete 
          :clearable="true" 
          :items="currentDocument.companydb_info.projects" 
          v-model="document_project" 
          label="Proyecto" 
          item-text="name" 
          item-value="id"
          style="margin-left: 10px;"
          :background-color="showRequiredProjectError?'#ff9898':'#ffffff'"
        ></v-autocomplete>
      </v-col>

      <v-col cols="10" sm="5" v-if="got_feature('feature_channel') && (currentDocument && currentDocument.companydb_info.companydb_type.params && currentDocument.companydb_info.companydb_type.params.show && currentDocument.companydb_info.companydb_type.params.show.includes('channel') && currentCompany && !currentCompany.hide_channels_master)">
        <v-autocomplete 
          :clearable="true" 
          :items="currentDocument.companydb_info.channels" 
          v-model="document_channel" 
          label="Canal" 
          item-text="name" 
          item-value="channel_id"
          style="margin-left: 10px;"
          
        ></v-autocomplete>
        <!-- :background-color="showRequiredProjectError?'#ff9898':'#ffffff'" -->
      </v-col>
      <v-col cols="10" sm="5" v-if="got_feature('feature_expense_income_type') && (currentDocument && currentDocument.companydb_info)">
        <v-autocomplete
            :clearable="true"
            :items="document_kind === 'in_invoice' ? expens_type : income_type"
            v-model="document_expens_income_type"
            :label=getExpensIncomeTypeLabel
            :item-text="item => item.code+' '+item.name"
            item-value="eit_id"
        ></v-autocomplete>
      </v-col>

      <v-progress-circular 
          v-if="loading_punteado"
          indeterminate
          color="primary"
        ></v-progress-circular>
      <v-col cols="2" sm="1" v-else-if="currentDocument && userData['available_features']['feature_can_mark_doc_as_punteado']">
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <div v-bind="attrs" v-on="on">
              <v-checkbox v-model="document_punteado"
                          @change="deepPunteadoState()"></v-checkbox>
            </div> 
          </template>
          <span>Punteado</span>
        </v-tooltip>
      </v-col>
    </v-row>
    <v-row no-gutters class="pl-4 pr-4">
      <v-col :cols="docStateCols">
        <v-select :readonly="true" :items="docState" v-if="currentDocument" v-model="currentDocument.state" label="Estado">
        </v-select>
      </v-col>
      <v-col cols="2" class="align-self-center" >
        <v-btn v-if="show_alert_btn()"
          max-width="50"
          min-width="50"
          class="ml-1 mb-2"
          :color="alertColor" 
          @click="showError()">
          <v-icon v-once>mdi-alert</v-icon>
        </v-btn>
        <div v-if="currentDocument && document_state === 'error_document_duplicated'">
          <v-tooltip bottom>
            <template #activator="{ on, attrs }">
              <v-btn 
                icon 
                class="ml-1 mb-2" 
                v-bind="attrs"
                v-on="on"
                @click="setSearchAndRedirectToList"
              >
                <v-icon>mdi-magnify</v-icon>
            </v-btn>
          </template>
          <span>Buscar duplicados</span>
        </v-tooltip>
      </div>
      </v-col>
      <v-col cols="1" class="align-self-center" v-if="(userData.is_staff || userData.hasOwnProperty('username') && session_information.hasOwnProperty('username') && (session_information.username != userData.username))">
        <v-progress-circular 
          v-if="loading_needs_tt_fix"
          indeterminate
          color="primary"
        ></v-progress-circular>
        <v-tooltip top v-else-if="currentDocument">
          <template v-slot:activator="{ on, attrs }">
            <div v-bind="attrs" v-on="on">
                <v-checkbox 
                  
                  class="ml-1 mb-2"
                  color="primary" 
                  v-model="document_needs_tt_fix"
                  @change="deepNeedsTtFixState"
                >
                </v-checkbox>
            </div> 
          </template>
          <span>Necesita revisión etiquetas</span>
        </v-tooltip>
      </v-col>
      <v-col cols="1" class="align-self-center" v-if="(userData.is_staff || userData.hasOwnProperty('username') && session_information.hasOwnProperty('username') && (session_information.username != userData.username))">
        <v-btn 
          class="ml-1 mb-2"
          color="primary" 
          icon
          @click="goMirrorDocument()"
          :disabled="!currentDocument"
        >
          <v-icon v-once>mdi-mirror</v-icon>
        </v-btn>
      </v-col>
      <v-col cols="1" class="align-self-center" v-if="(userData.is_staff || userData.hasOwnProperty('username') && session_information.hasOwnProperty('username') && (session_information.username != userData.username))">
        <v-btn 
          class="ml-1 mb-2"
          color="primary" 
          icon
          @click="goSimulatedMirrorDocument()"
          :disabled="!(currentDocument && document_has_simulated_mirror)"
        >
          <v-icon v-once>mdi-airplane</v-icon>
        </v-btn>
      </v-col>
      
      
    </v-row>
    <v-row>
      <v-col cols="12" v-if="currentDocument && currentDocument['metadata_old'] && fixMotxo">
        <v-text-field 
          style="margin-left: 10px;"
          v-model="currentDocument['metadata_old']" 
          label="metadata_old"
          readonly
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" :key="currentDocument.id.toString()+tags_changing.toString()"
      v-if="currentDocument && currentDocument['metadata_old'] && fixMotxo">
        <v-btn v-for="tag in currentDocument['tags']" :key="currentDocument.id.toString()+tag+tags_changing.toString()"
          style="margin-left: 10px;"
          label="tags"
          readonly
          @click="delete_tag_doc(tag)"
        >{{tag}}</v-btn>
      </v-col>
    </v-row>
    <v-row v-if="buzonView">
      <v-col cols="12" sm="10" v-if="currentDocument">
        <SelectorEmpresa
          style="margin-left: 10px;"
          name="SelectorEmpresa"
          :value="currentDocument.detected_company_id"
          :items="get_companydbs"
          :return_obj="false"
          :readonly="false"
          :item_val="'id'" 
          @gotInput="company_chosen_manually"
        ></SelectorEmpresa>
      </v-col>
    </v-row>
    

    <v-divider v-if="currentDocument"></v-divider>

    <invoice-info @invoice-date-changed="dateErrors_and_setDirty()" :key="currentDocument.id" v-if="currentCompany && currentDocument && ['in_invoice','out_invoice'].includes(currentDocument.kind) && !buzonView" />
    <!--<payroll-info v-if="currentDocument && ['payroll'].includes(currentDocument.kind)" @on_supplierdb_changed="on_supplierdb_changed" @on_customerdb_changed="on_customerdb_changed" />-->
    <template v-if="!buzonView">
      <v-row class="pa-4">
        <v-col cols="6"  class="pa-2" v-if="currentDocument && userData.available_features['feature_document_number'] && !got_feature('feature_document_number_prefix') && !got_feature('feature_document_number_str')">
          <doc-text-field 
              kind="number" 
              @change="setDirty()"
              v-model="currentDocument.doc_number" 
              label="Número de documento"
              class="mx-2" 
          />
        </v-col>
      </v-row>
      <v-row no-gutters class="pb-0 pt-1 pl-4" v-if="currentDocument && !['done', 'pending_upload','done_manually', 'done_with_warning','pending_sync','pending_connect','accounting_aplifisa_fiscal','accounting_invoice'].includes(currentDocument.state)">
        <!-- Fecha Contable -->
        <v-col cols="6" >
          <v-tooltip top :disabled="!errorAccountingDateSelect">
            <template v-slot:activator="{ on, attrs }">
              <div v-bind="attrs" v-on="on">
                <v-select 
                  @change="dateErrors_and_setDirty()" 
                  :disabled="!canSave()"
                  v-model="currentDocument.accounting_date_config" 
                  class="mx-2" 
                  label="Fecha contable" 
                  item-value="id" 
                  item-text="text" 
                  :items="ACCOUNTING_DATE_OPTIONS"
                  :background-color="errorAccountingDateSelect ? color.error : color.ok"
                ></v-select>
              </div> 
            </template>
            <span> {{ accountingTooltip }} </span>
          </v-tooltip>
        </v-col>
        <!-- ########## -->
        <!-- Text field Fecha Contable configurated -->
        <v-col cols="6" no-gutters class="pa-4" v-if="currentDocument && !['done','done_manually','done_with_warning','pending_sync','pending_connect', 'pending_upload', 'accounting_aplifisa_fiscal','accounting_invoice'].includes(currentDocument.state)">
          <v-tooltip top v-if="currentDocument.accounting_date_config == 'configurated'" :disabled="!errorAccountingDate">
            <template v-slot:activator="{ on, attrs }">
              <div v-bind="attrs" v-on="on">
                <doc-text-field  
                  kind="date" 
                  :required="currentDocument.accounting_date_config=='configurated'"
                  :disabled="!canSave()"
                  @input="dateErrors_and_setDirty()" 
                  :error="errorAccountingDate"
                  v-model="currentDocument.default_accounting_date" label="Fecha contabilización (DD/MM/YYYY)"
                ></doc-text-field>
              </div> 
            </template>
            <span> {{ accountingTooltip }} </span>
          </v-tooltip>
        </v-col>
        <!-- ########## -->
      </v-row>
      <v-row v-if="currentDocument && got_feature('feature_fecha_registro') && currentCompany && currentCompany.enable_fecha_sii && !['done','done_manually','done_with_warning','pending_sync','pending_connect', 'pending_upload', 'accounting_aplifisa_fiscal','accounting_invoice'].includes(currentDocument.state)" no-gutters class="pb-0 pt-1 pl-4">
        <!-- Fecha Registro : Select -->
        <v-col cols="6">
          <v-tooltip top :disabled="!errorRegistroDateSelect"">
            <template v-slot:activator="{ on, attrs }">
              <div v-bind="attrs" v-on="on">
                <v-select 
                  @change="dateErrors_and_setDirty()" 
                  :disabled="!canSave()"
                  v-model="currentDocument.registro_date_config" 
                  class="mx-2" 
                  label="Fecha Registro" 
                  item-value="id" 
                  item-text="text" 
                  :items="REGISTRO_DATE_OPTIONS"
                  :background-color="errorRegistroDateSelect ? color.error : color.ok"
                ></v-select>
              </div>
            </template>
            <span> {{ registroTooltip }} </span>
          </v-tooltip>
        </v-col>
        <!-- ########## -->
        <!-- Text field Fecha Registro configurated -->
        <v-col cols="6" no-gutters class="pa-4" v-if="currentDocument.registro_date_config=='configurated'">
        <v-tooltip top v-if="currentDocument.registro_date_config == 'configurated'" :disabled="!errorRegistroDate">
        <template v-slot:activator="{ on, attrs }">
          <div v-bind="attrs" v-on="on">
          <doc-text-field  
            kind="date" 
            :disabled="!canSave()"
            @input="dateErrors_and_setDirty()" 
            :error="errorRegistroDate"
            v-model="currentDocument.default_registro_date" label="Fecha registro (DD/MM/YYYY)"
          ></doc-text-field>
          </div>
        </template>
        <span> {{ registroTooltip }} </span>
        </v-tooltip>
        </v-col>
        <!-- ########## -->
      </v-row>
      
      <v-row class="pl-4 pt-2 pb-0" v-if="currentDocument">
        <v-col cols="12" sm="6" v-if="['done','done_manually','done_with_warning','pending_sync','pending_connect','accounting_aplifisa_fiscal','accounting_invoice', 'pending_upload'].includes(currentDocument.state)">
          <v-text-field :disabled="true" :readonly="true" v-model="currentDocument.accounting_date" label="Fecha contabilización">
          </v-text-field>
        </v-col>
        <v-col cols="12" sm="6" v-if="got_feature('feature_fecha_registro') && currentCompany && currentCompany.enable_fecha_sii && ['done','done_manually','done_with_warning','pending_sync','pending_connect','accounting_aplifisa_fiscal','accounting_invoice', 'pending_upload'].includes(currentDocument.state) && currentDocument.registro_date">
          <v-text-field :disabled="true" :readonly="true" v-model="currentDocument.registro_date" label="Fecha registro">
          </v-text-field>
        </v-col>
        <v-col cols="12" sm="6">
          <v-text-field v-if="currentDocument.companydb_info && currentDocument.companydb_info.companydb_type && currentDocument.companydb_info.companydb_type.type == 'invoice'" :disabled="currentDocument.state!='done'" :readonly="true" v-model="currentDocument.entry_number" label="Apunte">
          </v-text-field>
        </v-col>
      </v-row>

    </template>
    <v-list v-if="false" dense nav>
      <template
        v-for="label in $store.state.labels.human"
      >
        <v-list-item
          v-bind:key="label.name"
          class="pa-0"
        >
          <v-list-item-content
            class="pb-0 pt-1"
            :class="{selectedrow:label.name===selectedLabel}"
            style="height:50px"
          >
            <v-row no-gutters>
              <v-col 
                cols="1"
                class="pt-2 pb-0 pr-0"
              >
                <v-icon
                  v-if="label.name===selectedLabel" color="primary"
                  class="selected-chevron"
                >mdi-chevron-right</v-icon>
              </v-col>
              <v-col
                v-if="currentDocument"
                cols="9"
                class="pt-0 pb-0 pl-0 pr-0"
              >
                <doc-text-field
                  :field-class="{
                    invalid: ['error_validating_data','error_checking_taxes'].includes(currentDocument.state) && 
                    currentDocument.errorJson.includes(label.name)
                  }"
                  kind="text"
                  :label="label.text"
                  @focus="selectLabel({ label: label.name })"
                  v-model="that['metadata_'+label.name]"
                  :disabled="!currentDocument || currentDocument.forced_move || isWaitingFlow"
                ></doc-text-field>
              </v-col>
              <v-col cols="2" class="pt-0 pb-0 pr-0 pl-2">
                <v-btn
                  v-bind:color="label.color"
                  @click="selectLabel({ label: label.name })"
                  width="10"
                  min-width="10"
                  :disabled="!currentDocument || currentDocument.forced_move || isWaitingFlow"
                >
                  <v-icon>mdi-tag</v-icon>
                </v-btn>
              </v-col>
              
            </v-row>
          </v-list-item-content>
        </v-list-item>
      </template>
      <!-- TODO: remove-->
      <v-simple-table v-if="false">
        <template v-slot:default>
          <thead>
            <tr>
              <th width="130px" class="text-left">
                Type
              </th>
              <th class="text-left">
                Base
              </th>
              <th class="text-left">
                Tax
              </th>
            </tr>
          </thead>
          <tbody>
            <template
              v-for="label in $store.state.labels.taxes_labels"
              
            >
            <tr :key="'tax_'+label.name" v-if="currentDocument && currentDocument.metadata[label.name]"
            >
              <td>
                <v-text-field  readonly v-model="label.text"
                >
                </v-text-field>
              </td>
              <td><v-text-field
                  :class="{
                    invalid: ['error_validating_data','error_checking_taxes'].includes(currentDocument.state) && 
                    currentDocument.errorJson.includes(label.name)
                  }"
                  
                  @focus="selectLabel({ label: label.name })"
                  v-model="currentDocument.metadata['base_'+label.name]"
                  dense
                ></v-text-field></td>
              <td><v-text-field
                  :class="{
                    invalid: ['error_validating_data','error_checking_taxes'].includes(currentDocument.state) && 
                    currentDocument.errorJson.includes(label.name)
                  }"
                  
                  @focus="selectLabel({ label: label.name })"
                  v-model="currentDocument.metadata[label.name]"
                  dense
                ></v-text-field></td>
            </tr>
            </template>
            
          </tbody>
        </template>
      </v-simple-table>
    </v-list>
    <v-row v-if="userData.available_features['feature_see_currency'] && currentDocument && currentDocument.currency && !buzonView && !pending_states.includes(currentDocument.state)">
      <v-col cols="8" class="divisa">
        <v-text-field 
          v-if="available_currencies.length <= 0"
          style="padding-left: 25px;"
          v-model="currentDocument.currency"
          @change="setDirty()"
          label="Divisa de la factura"
          readonly
          :disabled="['pending_connect','accounting_aplifisa_fiscal','accounting_invoice','pending_sync','done','done_manually','done_with_warning', 'pending_upload'].includes(currentDocument.state)"
        ></v-text-field>
        <v-select
          v-else
          :items="available_currencies"
          style="padding-left: 25px;"
          v-model="currentDocument.currency"
          @change="currencyHasChanged()"
          label="Divisa de la factura"
          :disabled="['pending_connect','accounting_aplifisa_fiscal','accounting_invoice','pending_sync','done','done_manually','done_with_warning', 'pending_upload'].includes(currentDocument.state)"
        ></v-select>
        <v-tooltip top v-if="currentDocument && !('detected_amounts' in currentDocument.metadata) && currentDocument.currency != 'EUR' &&
        !['pending_connect','accounting_aplifisa_fiscal','accounting_invoice','pending_sync','done','done_manually','done_with_warning', 'pending_upload'].includes(currentDocument.state)">
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-bind="attrs"
              v-on="on"
              color="primary"
              class="ml-1 mb-2"
              :loading="loading_update_currency"
              @click="update_divisa"
              :disabled="dirty">
              a EUR
            </v-btn>
          </template>
          <span>Actualizar valores a EUR</span>
        </v-tooltip>
        <v-tooltip top v-if="currentDocument && 'detected_amounts' in currentDocument.metadata">
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-bind="attrs"
              v-on="on"
              color="primary"
              class="ml-1 mb-2"
              :loading="loading_restore_detected"
              @click="restore_detected"
              >
              a {{ currentDocument.currency }}
            </v-btn>
          </template>
          <span>Recuperar valores detectados</span>
        </v-tooltip>
      </v-col>
    </v-row>
    <v-row v-if="currentDocument && currentDocument.metadata && 'detected_amounts' in currentDocument.metadata && currency_info" class="under__text__divisa">
      <v-col cols="10">
        <span><strong>Tipo de cambio:</strong> {{ currency_info.name }} a EUR en fecha {{ currency_info.date }} con valor {{ currency_info.value }}.</span>
      </v-col>
    </v-row>

    <!-- Dialog show detectes values -->
    <v-dialog persistent v-model="show_popup_message_restore" max-width="600">
          <v-card>
            <v-card-title>
              <span class="text-h5 font-weight-bold py-1 ml-2">Aviso</span>
            </v-card-title>
            <v-divider></v-divider>
            <p class="px-3 ml-6 pt-5">¿Esta seguro que quiere restablecer las bases y cuotas?</p>
            <span class="primary--text px-3 ml-6">Bases y cuotas detectadas:</span>
            <v-card-text>
              <invoice-detected-info :key="currentDocument.id" v-if="currentCompany && currentDocument && ['in_invoice','out_invoice'].includes(currentDocument.kind)" />
            </v-card-text>
            <v-card-actions class="px-6">
              <v-spacer></v-spacer>
              <v-btn
                variant="text"
                @click="confirmRestoreDetected(false)"
              >
                Cancelar
              </v-btn>
              <v-btn
                variant="text"
                @click="confirmRestoreDetected(true)"
                color="primary"
                :disabled="currentDocument && ['pending_connect','accounting_aplifisa_fiscal','accounting_invoice','pending_sync','done','done_manually','done_with_warning', 'pending_upload'].includes(currentDocument.state)"
              >
                Aceptar
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

    <message-popup 
      title="Aviso"
      :show_message="show_popup_message"  
      :message="`<p>¿Esta seguro que quiere modificar las bases y cuotas a la divisa EUR ?</p>`"
      :actions="[{ 'action_text': 'Cancelar', 'emit': 'close-message' }, { 'action_text': 'Aceptar', 'emit': 'confirm-update-data', 'prin': true }]"
      @close-message="confirmCurrency(false)" 
      @confirm-update-data="confirmCurrency(true)"
    ></message-popup>

    <v-row v-if="got_feature('feature_invoice_notes')">
      <v-col cols="12">
        <v-text-field
            style="margin-left: 10px;"
            v-model="document_notes"
            label="Notas de factura"
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" v-if="currentDocument && currentDocument['originalFileName']">
        <v-text-field 
          style="margin-left: 10px;"
          v-model="currentDocument['originalFileName']" 
          label="Nombre del archivo"
          readonly
        ></v-text-field>
      </v-col>
    </v-row>
    <template v-if="got_feature('feature_ai_detected_lines')">
      <v-row v-if="currentDocument && currentDocument.static_invoice">
        <v-col>
          <v-btn style="margin-left: 10px;" primary @click="invoiceLinesPopUp()"> Ver líneas
            </v-btn>
        </v-col>
      </v-row>
      <v-row v-else>
        <v-col>
          <v-btn style="margin-left: 10px;" primary @click="detectarLineas()"> Detectar líneas
            </v-btn>
        </v-col>
      </v-row>
    </template>
    </div>
  </div>
</template>

<script>
import { client } from "@/api/client";
import { mapActions, mapGetters, mapState } from "vuex";
import DocTextField from "./DocTextField.vue";

import FixCIFPopup from '../components/FixCIFPopup.vue';
import JobProgress from '../components/JobProgress.vue';
import MessagePopup from '../components/MessagePopup.vue';
import InvoiceLinesEditorSimplified from "../components/InvoiceLinesEditorSimplified.vue"
import CreateCustomer from '../views/CreateCustomer.vue';
import CreateSupplier from '../views/CreateSupplier.vue';
import InvoiceInfo from './InvoiceInfo.vue';
import InvoiceDetectedInfo from './InvoiceDetectedInfo.vue';
import SelectorEmpresa from '../components/SelectorEmpresa.vue';
import DocumentHistoryComponent from '../components/DocumentHistoryComponent.vue';
import AppBtn from '@/components/layout/AppBtn.vue';
import AppModalCol from '@/components/layout/AppModalCol.vue';
import AppModalContainer from '@/components/layout/AppModalContainer.vue';
import AppModalPrompt from '@/components/layout/AppModalPrompt.vue';
import AppModalRow from '@/components/layout/AppModalRow.vue';
import AppAutocomplete from "@/components/layout/AppAutocomplete.vue";
import AppSelect from '@/components/layout/AppSelect.vue';

import { mapFields } from 'vuex-map-fields';

import { query_dispatcher, sync_command_dispatcher } from "@/api/client";
import { GetCurrencyCodeListQuery } from "@/modules/invoices/app/GetCurrencyCodeListQuery";
import { UpdateMetadataCurrencyCommand } from "@/modules/invoices/app/UpdateMetadataCurrencyCommand";
import { RestoreDetectedAmountsCommand } from "@/modules/invoices/app/RestoreDetectedAmountsCommand";
import { CreateXMLFromInvoice } from "@/modules/facturae/app/CreateXMLFromInvoice";
import { GetCurrencyInfoQuery } from "@/modules/invoices/app/GetCurrencyInfoQuery";
import { STANDARD_LABELS, STANDARD_LABELS_CLIENT } from "../store/constants";
import { ACCOUNTING_DATE_OPTIONS, REGISTRO_DATE_OPTIONS } from '../store/constants.js';
import { mapFieldsMetadata, vuexPrefix, vuexPrefix2 } from "../store/vuex_utils";
import { dateIsInPaths, isValidDate } from '../utils';

import {ApiInvoiceableRepository} from '../modules/facturae/infra/ApiInvoiceableRepository'

import { SelectDetectedCompany } from "@/modules/companies/application/SelectDetectedCompany";
import { TransferDocumentToOtherCompany } from "@/modules/companies/application/TransferDocumentToOtherCompany";
import { copyToClipboard } from "@/utils/common";

import { invoiceDateErrors, inAccountingPeriodErrors, diff5Years } from "@/modules/invoices/domain/Invoice"

import { VueFeatureRepository } from "../modules/shared/infra/FeatureRepository"
export default {
  name: "RightDrawerClientMode",
  components: {
    DocTextField,
    CreateSupplier,
    CreateCustomer,
    FixCIFPopup,
    InvoiceInfo,
    InvoiceDetectedInfo,
    JobProgress,
    MessagePopup,
    SelectorEmpresa,
    InvoiceLinesEditorSimplified,
    DocumentHistoryComponent,
    AppBtn,
    AppModalCol,
    AppModalContainer,
    AppModalPrompt,
    AppModalRow,
    AppAutocomplete,
    AppSelect,
  },
  data() {
    return {
      ACCOUNTING_DATE_OPTIONS,
      REGISTRO_DATE_OPTIONS,
      classification:'human',
      loading_previous: false,
      loading_next: false,
      loading_punteado: false,
      loading_needs_tt_fix:false,
      dialog: false,
      deleting: false,
      downloading: false,
      show_fix_cif_supplier: false,
      show_fix_cif_customer: false,
      supplierdb_selected: undefined,
      customerdb_selected: undefined,
      rotationPageMode: 'all',
      rotateProgressState: 'none',
      message: '',
      show_message: false,
      clearable_message:false,
      is_recording: false,
      menu:false,
      show_invoice_lines_pop_up: false,
      invoice_lines : [],
      chosen_company_id: undefined,

      changeCompanyDocDialog: false,
      simulateDocDialog: false,
      addTagsDocDialog: false,
      createTrainingDocDialog: false,
      historyPopup: false,

      companySimulate: null,
      tagsSimulate: [],
      accounting_date_config: 'invoice_date',
      default_accounting_date: null,
      invalid_default_accounting_date: false,
      default_accounting_date_error_message: undefined,

      companyChangeCompany: null,
      actividadChangeCompany: null,
      listActividadChangeCompany: [],
      tagsAddTags: [],
      tagsTraining: [],
      tags_changing:false,

      errorDialog: false,

      showErrorBtn: false,

      deleteProgressState: 'none',
      deleteJobId: 0,

      go_simulation_dialog: false,
      simulations: [],
      simulation_to_go: {},
      
      available_currencies: [],
      loading_update_currency: false,
      loading_restore_detected: false,
      currency: undefined,
      currency_info: undefined,
      show_popup_message: false,
      show_popup_message_restore: false,
      resolvePopupPromise:undefined,
      resolvePopupPromiseRestore:undefined,
      loading_detected_currency:false,
      pending_states: [
        "text_detected",
        "uploading_bucket",
        "pending",
        "preprocessing",
        "preprocessed",
        "assigned_contract",
        "nif_detected",
        "nif_validated",
        "data_detected",
        "data_formatted",
        "data_validated",
        "move_created",
        "move_loaded",
        "check_duplicated_ok",
        "accounts_assigned",
        "split" ,
        "human_annotated",
        "oriented",
        "move_validated",
        "merging",
        "not_simulated",
        "in_rotation",
        "accounting_payment_move",
        "third_accounts_validated",
        "backtracking",
        "pending_approval",
        "waiting_signature",
        "company_detected",
        "detecting_company",
        "sync_payment_move"
      ],
      // ==========
      // ==========
      date_tooltips: {
        no_acc_period: "No existe en la empresa ningún ejercicio para esta fecha",
        acc_date_before_invoice: "La Fecha contable debe ser igual o posterior a la Fecha factura",
        // reg_date_before_accounting: "La Fecha de registro debe ser igual o posterior a la Fecha contable y a la Fecha factura",
        reg_date_before_invoice: "La Fecha registro debe ser igual o posterior a la Fecha factura",
        acc_inv_5y: "El periodo de la Fecha contable a la de factura debe ser inferior a 5 años",
        no_future_date: "Las fechas factura y contable no pueden ser posteriores a la fecha actual"
      },
      date_errors: {invoice : false, accounting : false, registro : false},
      inAccounting_errors: {invoice : false, accounting : false, registro : false},
      error5years: null,
      color: { ok : '#ffffff', error : '#ff9898'},
      // ==========
      // ==========
    }
  },
  computed: {
    buzonView(){
      return this.currentCompany && this.currentCompany.companydb_type.value == 'inbox'
    },
    showRetry() {
      if (!this.currentDocument) return false
      return (
        (((this.currentDocument.state.startsWith("error_") && !['error_text_detection','error_format'].includes(this.currentDocument.state)) || ['required_review'].includes(this.currentDocument.state)) && !this.currentDocument.forced_move)
        ||
        (this.dirty && (['pending_review'].includes(this.currentDocument.state) || this.currentDocument.forced_move))
        ||
        (['pending_approval'].includes(this.currentDocument.state))
      )
    },
    showContabilize() {
      if (!this.currentDocument) return false
      return (
        !this.dirty
        &&
        (['pending_review'].includes(this.currentDocument.state) || this.currentDocument.forced_move)
        &&
        !['done','done_manually','done_with_warning','pending_sync','pending_connect','accounting_aplifisa_fiscal','accounting_invoice', 'pending_upload'].includes(this.currentDocument.state)
        &&
        !(this.currentCompany && this.currentCompany.companydb_type.params && this.currentCompany.companydb_type.params['contabilize_on_csv'])
      )
    },
    existsMoreThanOneDocument() {
      return this.currentDocuments.length > 0
    },
    canGoToNextDocument() {
      return this.existsCurrentIndex && this.existsMoreThanOneDocument && !(this.currentIndex >= this.currentDocuments.length-1 && !this.currentPagination.next);
    },
    canGoToPreviousDocument() {
      return this.existsCurrentIndex && this.existsMoreThanOneDocument && !(this.currentIndex <= 0 && !this.currentPagination.previous);
    },
    alertColor(){
      if (this.currentDocument && ['required_review', 'done_with_warning'].indexOf(this.currentDocument.state) > -1){
        return "#FFE750" 
      }
      else{
        return "var(--v-error-base)" 
      }
    },
    docStateCols(){
      if(this.userData.is_staff || this.userData.hasOwnProperty('username') && this.session_information.hasOwnProperty('username') && (this.session_information.username != this.userData.username)){
        return 7
      }
      else{
        return 10
      }
    },
    activityError(){
      let color = 'rgba(0,0,0,0)';
      const inErrorState = ['error_validating_data','error_checking_taxes'].includes(this.currentDocument.state);
      if (this.got_feature('feature_revision_required_actividad') && inErrorState && this.currentDocument.errorJson.includes('actividad')) {
        color = '#ff9898';
      }
      if (this.got_feature('feature_actividad_str_obligatoria') && inErrorState && this.currentDocument.errorJson.includes('actividad_str')) {
        color = '#ff9898';
      }
      return color;
    },
    ...mapGetters({
      fixMotxo: "fixMotxo",
      availableTags: "availableTags",
      creatingMoves: "accounts/creatingMoves",
      flowLoading: "documents/flowLoading",
      documentWriting: "documents/documentWriting",
      currentDocument: "documents/currentDocument",
      selectedLabel: "documents/selectedLabel",
      selectedTextPayload: "documents/selectedTextPayload",
      currentDocuments: "documents/currentDocuments",
      currentIndex: "documents/currentIndex",
      currentPagination: "documents/currentPagination",
      docState: "documents/docState",
      tags: "get_tags",
      suppliers: "get_suppliers",
      customers: "get_customers",
      userData: 'me/userData',
      documentIsTrainerMode: 'documents/documentIsTrainerMode',
      dirty: 'documents/dirty',
      currentCompany: "getCurrentCompany",
      isWaitingFlow: "documents/isWaitingFlow",
      inRotationMode: "documents/inRotationMode",
      availableDocs: "me/availableDocs",
      rotateJobId:"documents/rotateJobId",
      get_companydbs: 'get_companydbs',
      permission: 'permissions/permission',
      existsCurrentIndex: 'documents/existsCurrentIndex',
      getIntActivities:'getIntActivities',
      got_feature: 'got_feature',
    }),
    ...mapFieldsMetadata(vuexPrefix('metadata_',STANDARD_LABELS.map(x=>x.name),'')),
    ...mapFieldsMetadata(vuexPrefix('metadata_',STANDARD_LABELS_CLIENT.map(x=>x.name),'')),
    ...mapFields('documents',vuexPrefix('document_',[
      'kind','state','supplierdb','customerdb','supplierdb_info','customerdb_info','actividad','has_mirror', 
      'has_simulated_mirror', 'punteado', 'project', 'channel', 'actividad_str','needs_tt_fix', 'notes',
      'expens_income_type',
    ],'document.')),
    // ...mapFields(['showModalSupplier','showModalCustomer']),
    ...mapFields('documents', ['documentIsDebuggerMode', 'documentAction']),
    ...mapFields('documents', vuexPrefix2('doc_', ['values'], 'documentListFiltersData2.', [  'tags', ])),
    ...mapFields(["projects", "channels", "activities", "expens_type", "income_type"]),
    that(){
      return this
    },
    ...mapState([
      'session_information',
    ]),
    // ==========
    // ==========
    errorInvoiceDate() {
      return this.date_errors.invoice || this.error5years === true
    },
    invoiceTooltip() {
      if (this.error5years === true) return this.date_tooltips.acc_inv_5y
      else return ""
    },
    errorAccountingDate() {
      return this.date_errors.accounting || this.inAccounting_errors.accounting
    },
    errorAccountingDateSelect() {
      return this.errorAccountingDate && this.currentDocument.accounting_date_config != 'configurated'
    },
    accountingTooltip() {
      return this.inAccounting_errors.accounting ? this.date_tooltips.no_acc_period : this.date_tooltips.acc_date_before_invoice
    },
    errorRegistroDate() {
      // removed check date in accounting period
      return this.date_errors.registro
    },
    errorRegistroDateSelect() {
      return this.errorRegistroDate && this.currentDocument.registro_date_config != 'configurated'
    },
    registroTooltip() {
      // return this.inAccounting_errors.registro ? this.date_tooltips.no_acc_period : this.date_tooltips.reg_date_before_accounting
      return this.date_tooltips.reg_date_before_invoice
    },
    // ==========
    // ==========
    showRequiredProjectError(){
      return this.currentDocument.state == 'error_missing_fields' && this.currentDocument.errorJson['missing_fields'].includes('project') && !this.document_project
    },
    invoice_error() {
      try {
        return this.currentDocument.error;
      } catch {
        return '';
      }
    },
    account_moves_errors() {
      try {
        let errors = [];
        for (let i in this.currentDocument.accountMoves) {
          let am = this.currentDocument.accountMoves[i];
          if (am.error) {
            errors.push({ 'id': am.id, 'error': am.error })
          }
        }
        return errors;
      } catch {
        return [];
      }
    },
    getActions() {
      let actions = [];
      for (let i in this.documentAction) {
        if (['add_tags_doc'].includes(this.documentAction[i]['id'])) {
          if (this.userData && this.userData.is_staff) {
            actions.push(this.documentAction[i]);
          }
        } else if (['create_training_doc', 'check_document_history'].includes(this.documentAction[i]['id'])) {
          if (this.userData && (this.userData.is_staff || (this.session_information && this.session_information.username != this.userData.username))) {
            actions.push(this.documentAction[i]);
          }
        } else if (['simulate_doc'].includes(this.documentAction[i]['id'])) {
          if (this.userData && this.userData.can_see_training_documents) {
            actions.push(this.documentAction[i]);
          }
        } else if (['mark_as_pending_review'].includes(this.documentAction[i]['id'])) {
          if (this.userData && this.userData['available_features']['feature_can_mark_doc_as_pending_review']) {
            actions.push(this.documentAction[i]);
          }
        } else if (['force_docs_state_to_done'].includes(this.documentAction[i]['id'])) {
          if (this.userData && this.userData['available_features']['feature_can_force_docs_to_done']) {
            actions.push(this.documentAction[i]);
          }
        } else {
          actions.push(this.documentAction[i]);
        }
      }
      actions.push({
          "id": "change_view",
          "name": "Vista Nueva"
      })
      return actions;
    },
    activitySwitcher(){
      if (this.currentCompany && this.currentCompany.companydb_type.params && this.currentCompany.companydb_type.params.activity_format === 'number'){
        return this.getIntActivities
      }
      else {
        return this.activities
      }
    },
    getFileurl(){
      let original = this.currentDocument.signed_original_url
      return original ? original : this.currentDocument.signed_url
    },
    getFileName(){
      let filename = 'doc_'+this.currentDocument.id.toString()
      //console.log(this.currentDocument)
      if (this.currentDocument.supplierName){
        filename += '_'+this.currentDocument.supplierName.replace(' ','_')
        }
      else if(this.currentDocument.customerName){
        filename += '_'+this.currentDocument.customerName.replace(' ','_')
      }
      if (this.currentDocument.originalFileName){
        filename += '_'+this.currentDocument.originalFileName
        }
      if(!this.currentDocument.excel_kind && !this.currentDocument.excel_line_index && !this.currentDocument.static_invoice){
        filename+='.pdf'
      }
      return filename
    },
    getExpensIncomeTypeLabel(){
      return this.document_kind === 'in_invoice' ? 'Tipo de Gasto' : 'Tipo de Ingreso';
    },
  },
  watch: {
    'currentDocument': {
      handler (newVal, old) {
        if (newVal && this.userData.available_features['feature_see_currency']) {
            this.currency = this.currentDocument.currency
        }
        if (old == null && newVal != null) this.setDateErrors()
      },
      immediate: true
    }
  },
  async mounted() {
    window.addEventListener('keydown', this.handleKeyDown);
    if(this.userData.available_features['feature_see_currency']) {
      try {
        await new GetCurrencyCodeListQuery(query_dispatcher, this).run()
      } catch (error) {
        console.error('Error get currency code list', error);
      }
    }
    await this.getCurrencyInfo()
  },
  destroyed() {
    window.removeEventListener('keydown', this.handleKeyDown)
  },
  methods: {
    // ==========
    // ==========
    setDateErrors(){
      this.date_errors = invoiceDateErrors(
      this.currentDocument.metadata['invoice_date'],
      this.currentDocument.default_accounting_date,
      this.currentDocument.accounting_date_config,
      this.currentDocument.default_registro_date,
      this.currentDocument.registro_date_config,
      new VueFeatureRepository(this.got_feature),
      )
      this.inAccounting_errors = inAccountingPeriodErrors(
      this.currentDocument.metadata['invoice_date'],
      this.currentDocument.default_accounting_date,
      this.currentDocument.accounting_date_config,
      this.currentDocument.default_registro_date,
      this.currentDocument.registro_date_config,
      this.currentDocument['paths']
      )
      this.error5years = diff5Years(this.currentDocument.metadata['invoice_date'], this.currentDocument.default_accounting_date, this.currentDocument.accounting_date_config)
    },
    dateErrors_and_setDirty(){
      this.setDateErrors()
      this.setDirty()
    },
    // ==========
    // ==========
    async company_chosen_manually(input){
      await new SelectDetectedCompany(sync_command_dispatcher).run(input,this.currentDocument.id)
      this.fetchDocumentMetadata({ id: this.currentDocument.id })
    },
    async transfer_to_detected_company(){
      await new TransferDocumentToOtherCompany(sync_command_dispatcher).run(this.currentDocument.id)
      this.$router.push({ path: '/'+this.currentCompany.id.toString()+'/documents' })
    },
    confirm(){
      this.show_popup_message = true;
      return new Promise((resolve,reject)=>{
        this.resolvePopupPromise = resolve
      })
    },
    confirmCurrency(res){
      this.show_popup_message = false;
      this.resolvePopupPromise(res)
    },
    loading_update_values(value) {
      this.loading_update_currency = value;
    },
    async update_divisa(){
      try {
        let date = this.currentDocument.metadata['invoice_date']
        await new UpdateMetadataCurrencyCommand(sync_command_dispatcher, this).run(this.currentDocument.currency, date, this.currentDocument.id, this.userData.user)
      } catch (error) {
        console.error('Error update metadata with currency value', error);
      }
      this.currencyHasChanged()
    },
    confirm_restore(){
      this.show_popup_message_restore = true;
      return new Promise((resolve,reject)=>{
        this.resolvePopupPromiseRestore = resolve
      })
    },
    confirmRestoreDetected(res){
      this.show_popup_message_restore = false;
      this.resolvePopupPromiseRestore(res)
    },
    loading_update_restore(value) {
      this.loading_restore_detected = value;
    },
    async restore_detected(){
      try {
        await new RestoreDetectedAmountsCommand(sync_command_dispatcher, this).run(this.currentDocument.id, this.userData.id)
      } catch (error) {
        console.error('Error restore metadata with detected currency', error);
      }
      this.currencyHasChanged()
    },
    currencyHasChanged() {
      this.setDirty();
      this.reintentar();
      this.getCurrencyInfo();
    },
    async getCurrencyInfo() {
      if (this.currentDocument && 'detected_amounts' in this.currentDocument.metadata) {
        try {
          let currency_id = this.currentDocument.metadata["detected_amounts"]["currency_id"]
          await new GetCurrencyInfoQuery(query_dispatcher, this).run(currency_id)
        } catch (error) {
          console.error('Error get currency info', error);
        }
      }
    },
    handleKeyDown(e) {
      // ctrl + keyCode shortcuts
      if (!e.ctrlKey) return
      switch(e.keyCode) {
        case 13: // ctrl + enter
          this.onCtrlEnter()
          break
        case 37: // ctrl + ArrowLeft
          this.handlePrevious()
          break
        case 39: // ctrl + ArrowRight
          this.handleNext()
          break;
        case 121: // ctrl + F10
          this.showErrorBtn = !this.showErrorBtn;
          break;
        default:
          break
      }
    },
    onCtrlEnter() {
      if (!this.isWaitingFlow && (this.showRetry || this.showContabilize)) {
        this.continueFlow2()
      }
    },
    handleNext() {
      if (!this.isAnyInputFocused() && this.canGoToNextDocument) {
        this.next_document()
      }
    },
    handlePrevious() {
      if (!this.isAnyInputFocused() && this.canGoToPreviousDocument) {
        this.previous_document()
      }
    },
    isAnyInputFocused() {
      const inputTypes = ['input', 'select', 'button', 'textarea']
      return inputTypes.includes(document.activeElement.tagName.toLowerCase())
    },
    enter() {
      this.saveLabels({ and_go_back_to: "/documents" });
    },
    toggleRotationMode() {
      this.setRotation(!this.inRotationMode)
    },
    start_check_async_job_state(id){
      this.check_async_job_state(id)
    },
    fix_cif_supplier(cif){
      this.fixCompanyCIF({company_id:this.supplierdb_selected.id,cif:cif,url:'supplierdbs/'}).then(()=>{
        this.setSuppliers(this.currentCompany['id'])
        this.show_fix_cif_supplier=false;
      })
    },
    fix_cif_customer(cif){
      this.fixCompanyCIF({company_id:this.customerdb_selected.id,cif:cif,url:'customerdbs/'}).then(()=>{
        this.setCustomers(this.currentCompany['id'])
        this.show_fix_cif_customer=false;
      })
    },

    check_async_job_state(id){
      if(id==this.$store.state.documents.document.id.toString()){
          this.fetchDocumentMetadata({ id: this.$store.state.documents.document.id }).then(() => {
          if(['pending','running'].includes(this.$store.state.documents.document.async_job_state)){
            setTimeout(()=>this.check_async_job_state(this.$store.state.documents.document.id),3000)
          }
          else{
            this.resetThirdsIfNeeded()
          }
        })
      }
      
    },
    continueFlow2(){
      this.continueFlow().then(()=>{
        if(['pending','running'].includes(this.currentDocument.async_job_state)){
          setTimeout(()=>this.start_check_async_job_state(this.currentDocument.id),3000)
        } else if (this.currentDocument.async_job_state === "done" && this.is_recording) {
          if (this.canGoToNextDocument && ['done', 'pending_connect', 'accounting_aplifisa_fiscal','accounting_invoice'].includes(this.$store.state.documents.document.state)) {
            this.next_document();
          }
          this.is_recording = false;
        }
        else{
          this.resetThirdsIfNeeded()
        }
      })
    },
    resetThirdsIfNeeded(){
      if(this.currentDocument.kind=='in_invoice' && this.currentDocument.supplierdb_info){
        let id = this.currentDocument.supplierdb_info.id
        let list_of_ids = this.suppliers.map(x=>x.id)
        if(!list_of_ids.includes(id)){
          this.setSuppliers(this.currentCompany['id'])
        }
      }
      else if(this.currentDocument.kind=='out_invoice' && this.currentDocument.customerdb_info){
        let id = this.currentDocument.customerdb_info.id
        let list_of_ids = this.customers.map(x=>x.id)
        if(!list_of_ids.includes(id)){
          this.setCustomers(this.currentCompany['id'])
        }
      }
    },
    saveDocument() {
      this.saveDocWithoutContinueFlow();
    },
    reintentar() {
      this.continueFlow2();
    },
    contabilizar() {
      this.is_recording = true;
      this.continueFlow2();
    },
    delete_document(){
      this.dialog = true
    },
    deleteItem(){
      this.dialog = false
      this.deleting = true;
      client.post("delete_documents/" , { 'doc_ids': [this.currentDocument.id] }).then(resp => {
        this.deleteJobId = resp.data['AsyncJob'];
        this.deleteProgressState = 'running';
      });
    },
    deleteItemDone() {
      this.deleting = false;
      this.deleteJobId = 0;
      if(this.currentDocuments.length>0 && !(this.currentIndex==this.currentDocuments.length-1 && !this.currentPagination.next)){
        this.next_document()
      } else {
        this.$router.push({name:'document-list'});
      }
    },

    delete_tag_doc(t){
      this.tags_changing=true
      client.post("delete_tag_doc/" , {'doc_id':this.currentDocument.id,'tag':t})
        .then(() => {
            this.fetchDocumentMetadata({ id: this.$store.state.documents.document.id })
            .then(() => {
              this.tags_changing=false
            })
      })
    },
    async invoiceLinesPopUp(){
      let static_invoice_repo = new ApiInvoiceableRepository()
      let inv = await static_invoice_repo.find_by_id(this.currentDocument.static_invoice)
      console.log(inv)
      this.invoice_lines = inv.lines
      this.show_invoice_lines_pop_up = true
    },

    async detectarLineas(){
      let command_dispatcher = sync_command_dispatcher
      let res = await command_dispatcher.dispatch('detect.document.lines', { doc_id: this.currentDocument.id })
      console.log(res)
    },
    noDeleteItem(){
      this.dialog = false

    },
    previous_document(){
      this.loading_previous=true
      if(this.currentIndex>=1){
        var params = { name: "document-detail", params: { document: this.currentDocuments[this.currentIndex-1].id.toString() } };
        this.selectLabel({ label: null });
        this.$router.push(params);
        this.fetchDocument({ id: this.currentDocuments[this.currentIndex-1].id }).then(() => {})
        this.setCurrentIndex(this.currentIndex-1)
        this.loading_previous=false
      }
      else{
        let url_split=this.currentPagination.previous.split('/api')
        let url = url_split[url_split.length-1]
        client.get(url).then(response => {
          this.setCurrentDocs(response.data);
          let ind = response.data.results.length-1;
          this.setCurrentIndex(ind);
          if (this.currentDocuments.length) {
            var params = { name: "document-detail", params: { document: this.currentDocuments[ind].id.toString() } };
            this.selectLabel({ label: null });
            this.$router.push(params);
           this.fetchDocument({ id: this.currentDocuments[ind].id }).then(() => {})
          } else {
            var params = { name: "document-list" };
            this.$router.push(params);
          }
          this.loading_previous=false
        });
      }
    },
    next_document(){
      this.loading_next=true
      if(this.currentIndex+1<=this.currentDocuments.length-1){
        var params = { name: "document-detail", params: { document: this.currentDocuments[this.currentIndex+1].id.toString() } };
        this.selectLabel({ label: null });
        this.$router.push(params);
        this.fetchDocument({ id: this.currentDocuments[this.currentIndex+1].id }).then(() => {})
        this.setCurrentIndex(this.currentIndex+1)
        this.loading_next=false
      }
      else{
        let url_split=this.currentPagination.next.split('/api')
        let url = url_split[url_split.length-1]
        client.get(url).then(response => {
          this.setCurrentDocs(response.data);
          this.setCurrentIndex(0);
          if (this.currentDocuments.length) {
            var params = { name: "document-detail", params: { document: this.currentDocuments[0].id.toString() } };
            this.selectLabel({ label: null });
            this.$router.push(params);
            this.fetchDocument({ id: this.currentDocuments[0].id }).then(() => {})
          } else {
            var params = { name: "document-list" };
            this.$router.push(params);
          }
          this.loading_next=false
        });
      }
    },
    changeDrawerMode() {
      // this.setIsTrainerMode(!this.documentIsTrainerMode);
      this.documentIsDebuggerMode = !this.documentIsDebuggerMode;
    },
    ...mapActions({
      createMoveLines: "accounts/createMoveLines",
      continueFlow: "documents/continueFlow",
      deleteLabel: "documents/deleteLabel",
      selectLabel: "documents/selectLabel",
      saveLabels: "documents/saveLabels",
      setCurrentIndex: "documents/setCurrentIndex",
      fetchDocument: "documents/fetchDocument",
      fetchDocumentMetadata:"documents/fetchDocumentMetadata",
      setCurrentDocs: "documents/setCurrentDocs",
      setIsTrainerMode: "documents/setIsTrainerMode",
      generateFilters: "documents/generateFilters",
      setFiltersDataSearchValue: "documents/setFiltersDataSearchValue",
      setFiltersDataSearchDuplicateValue:"documents/setFiltersDataSearchDuplicateValue",
      setDocumentKind:"documents/setDocumentKind",
      downloadFile:"documents/downloadFile",
      setRotation:"documents/setRotation",
      setRotationMode:"documents/setRotationMode",
      cancelRotationMode:"documents/cancelRotationMode",
      saveRotation:"documents/saveRotation",
      setCustomers: "setCustomers",
      setSuppliers: "setSuppliers",
      fixCompanyCIF: "fixCompanyCIF",
      setDirty: "documents/setDirty",
      changeTrainerMode: "changeTrainerMode",
      getMirrorDocument: "documents/getMirrorDocument",
      getSimulatedMirrorDocument: "documents/getSimulatedMirrorDocument",
      getSimulationsFromTrainingDocument: "documents/getSimulationsFromTrainingDocument",
      setLoginas: "setLoginas",
      unsetLoginas: "unsetLoginas",
      splitDocument: "splitDocument",
      markDocsAsPendingReview: "documents/markDocsAsPendingReview",
      forceDocsStateToDone: "documents/forceDocsStateToDone",
      markAsPunteado: "documents/markAsPunteado",
      markAsDespunteado: "documents/markAsDespunteado",
      setNeedsTtFixState:"documents/setNeedsTtFixState",
      saveDocWithoutContinueFlow: "documents/saveDocWithoutContinueFlow",
      getCompanyActivities: "documents/getCompanyActivities",
      forceDocsSendInvoice: "documents/forceDocsSendInvoice",
    }),
    async deepPunteadoState(){
      this.loading_punteado = true
      if (this.currentDocument.punteado){
        await this.markAsPunteado({ send_filters:false, docs:[this.currentDocument.id] })
        this.loading_punteado = false
      }
      else{
        await this.markAsDespunteado({ send_filters:false, docs:[this.currentDocument.id] })
        this.loading_punteado = false
      }
    },
    async deepNeedsTtFixState(val){
      this.loading_needs_tt_fix = true
      await this.setNeedsTtFixState({value:val, docs:[this.currentDocument.id] })
      this.loading_needs_tt_fix = false
    },
    doRotation() {
      this.saveRotation().then(() => {
        this.rotateProgressState = "running"
      })
    },
    rotateDone() {
      window.location.reload()
    },
    showError() {
      let t=''
      this.clearable_message = false
      if(this.currentDocument.kind=='in_invoice'){
        t='proveedor'
      }else{
        t='cliente'
      }
      if (['required_review', 'done_with_warning'].indexOf(this.currentDocument.state) > -1){
        this.message = ''
        for(let i in Object.keys(this.currentDocument.warningJson)){
          let key =  Object.keys(this.currentDocument.warningJson)[i]
          this.message += this.currentDocument.warningJson[key] +"<br>"
        }
        this.clearable_message = true
      }
      else if (
        this.currentDocument.state == 'error_validating_moves'
        && this.currentDocument.errorJson
        && this.currentDocument.errorJson.user_error
        ) {

        const errorsHTML = `
          <p>Por favor, revise los siguientes errores:</p>
          <ul>
            ${this.currentDocument.errorJson.user_error.map(error => `<li>${error}</li>`).join('')}
          </ul>
        `
        this.message = errorsHTML
      }
      else if (this.currentDocument.state=='error_missing_fields'){
        let val_t_txt = {
          'project':'Proyecto',
          'description_sii':'Descripcion SII',
          'retention_type_name':'Tipo de retencion',
          'inv_number_to_rectify': 'Nº factura rectificada',
          'inv_date_to_rectify': 'Fecha factura rectificada',
          'vat_supplier': 'CIF Proveedor',
          'supplier': 'Nombre Proveedor',
          'vat_customer': 'CIF Cliente',
          'customer': 'Nombre Cliente',
          'rebu_precio_compra': 'Precio de compra REBU'
        }
        this.message = 'Faltan los campos obligatorios:<br>'
        for(let i in this.currentDocument.errorJson['missing_fields']){
          let field = val_t_txt[this.currentDocument.errorJson['missing_fields'][i]]
          this.message += "· "+field +"<br>"
        }
      } else if (this.currentDocument.state=='error_not_supported_operation'){
        this.message=this.currentDocument.error;
      } else if(this.currentDocument.state=='error_checking_taxes') {
        this.message=this.currentDocument.error;
      } else if (this.currentDocument.error.includes('FiscalAccountDoesNotExist')){
        this.message='La cuenta del '+t+' no existe en el programa contable';
      } else if (this.currentDocument.error.includes('EjercicioCerrado')){
        this.message='El ejercicio está cerrado en el programa contable';
      } else if (this.currentDocument.error.includes('AccountDoesNotExist')){
        this.message='Alguna de las cuentas del asiento no existe en el programa contable';
      } else if(this.currentDocument.error.includes('Faltan las siguientes cuentas en el destino:') || this.currentDocument.error.includes('Los siguientes campos no pueden estar vacíos:') ){
        this.message=this.currentDocument.error;
      } else if (this.currentDocument.error.includes('ContanetNSTPathDoesNotExist')) {
        this.message='No se ha podido encontrar la empresa en la ruta .NST';
      } else if (this.currentDocument.error.includes('Suplidos account not configured')) {
        this.message='Cuenta de suplidos no configurada';
      } else if (this.currentDocument.error.includes('DatabaseError') && this.currentDocument.error.includes('Problematic key') && this.currentDocument.error.includes('CLAVEDAT') && this.currentDocument.error.includes('EJERCICIO') && this.currentDocument.error.includes('ACTIVIDAD')) {
        this.message='Es posible que la actividad sea incorrecta o el ejercicio no este disponible para esta empresa en Aplifisa Fiscal';
      } else if (this.currentDocument.error.includes('Se produjo un error en el cálculo del IVA/IGIC') && this.currentDocument.error.includes('Se ha grabado el apunte, pero debe comprobar el Tipo, la Base y el Total')) {
        this.message='Contanet ha dado el siguiente error: "Se produjo un error en el cálculo del IVA/IGIC. Se ha grabado el apunte, pero debe comprobar el Tipo, la Base y el Total". Es posible que el problema sea que algún Id de los IVA/IGIC no esté bien configurado en la empresa';
      } else if (this.currentDocument.error.includes('PermissionError: [Errno 13] Permission denied:') && this.currentDocument.error.includes('Inmatic.xlsx')){
        this.message="No se ha podido escribir en el fichero Excel, parece que el fichero estaba abierto. Cierre el Excel y reintente el documento."
      } else if (this.currentDocument.error.includes('Documento requiere contraseña')){
        this.message="No se pudo abrir el fichero, documento requiere contraseña"
      } else if (this.currentDocument.error.includes('Por alguna razón nos ha sido imposible acceder a la empresa,')) {
        this.message = this.currentDocument.error;
      } else if(this.currentDocument.error.includes('Contacta con ')) {
        this.message = this.currentDocument.error;
      } else if (this.currentDocument.error.includes('Payment Innuva Error')) {
        let pm = 'pago'
        if (t=='cliente') {
          pm = 'cobro'
        }
        this.message = `La factura se ha contabilizado, pero ha habido un error al crear el ${ pm } en Innuva, verifique que esta todo correcto.`
      } else if(this.currentDocument.error.includes('Error en la contabilización')) {
        this.message = this.currentDocument.error;
      } else if(this.currentDocument.error.includes('[Errno 13] Permission denied') &&
                this.currentDocument.error.includes('xslx.py') && 
                this.currentDocument.error.includes('zipfile.py')){
        this.message = "Parece ser que el Excel de carga está abierto por otro programa, cierre el fichero y vuelva a contabilizar la factura."
      } else if(this.currentDocument.error.includes('user_error')) {
      let json_msg=''
      try{
        json_msg=JSON.parse(this.currentDocument.error.replace(/'/g, '"'))
      }
      catch(e){
        json_msg=JSON.parse(this.currentDocument.error)
      }
        const errorsHTML = `
          <p>Por favor, revise los siguientes errores:</p>
          <ul>
            ${json_msg.user_error.map(error => `<li>${error}</li>`).join('')}
          </ul>
        `
        this.message = errorsHTML
      }
      this.show_message=true;
    },
    closeMessage(){
      this.show_message=false;
      if (this.currentDocument.state=='required_review'){
        client.patch('finish_required_review/',{'doc_id':this.currentDocument.id}).then(() => {
          this.message = ''  
          this.fetchDocument({ id: this.currentDocument.id})
        }).catch(err=>{
          console.error(err);
        });
      }
    },
    show_alert_btn(){
      if(this.currentDocument && (((this.currentDocument.state=='error_account_connector' && 
         (
          this.currentDocument.error.includes('Payment Innuva Error') ||
          this.currentDocument.error.includes('FiscalAccountDoesNotExist') ||
          this.currentDocument.error.includes('EjercicioCerrado') ||
          this.currentDocument.error.includes('AccountDoesNotExist') ||
          this.currentDocument.error.includes('Faltan las siguientes cuentas en el destino:') ||
          this.currentDocument.error.includes('Los siguientes campos no pueden estar vacíos:') ||
          this.currentDocument.error.includes('Error en la contabilización') ||
          this.currentDocument.error.includes('ContanetNSTPathDoesNotExist') ||
          this.currentDocument.error.includes('Suplidos account not configured') ||
          this.currentDocument.error.includes('Por alguna razón nos ha sido imposible acceder a la empresa,') ||
          this.currentDocument.error.includes('user_error') ||
          (
            this.currentDocument.error.includes('[Errno 13] Permission denied') &&
            this.currentDocument.error.includes('xslx.py') && 
            this.currentDocument.error.includes('zipfile.py')
          ) ||
          (this.currentDocument.error.includes('PermissionError: [Errno 13] Permission denied:') && this.currentDocument.error.includes('Inmatic.xlsx')) ||
          (this.currentDocument.error.includes('Se produjo un error en el cálculo del IVA/IGIC') && this.currentDocument.error.includes('Se ha grabado el apunte, pero debe comprobar el Tipo, la Base y el Total')) ||
          (
            this.currentDocument.error.includes('DatabaseError') && 
            this.currentDocument.error.includes('Problematic key') && 
            this.currentDocument.error.includes('CLAVEDAT') && 
            this.currentDocument.error.includes('EJERCICIO') && 
            this.currentDocument.error.includes('ACTIVIDAD')
          ) || this.currentDocument.error.includes('Contacta con ')
         ) ||  ( this.currentDocument.state=='error_format' && this.currentDocument.error.includes('Documento requiere contraseña')))
         ) || (['required_review', 'error_critical', 'error_missing_fields', 'done_with_warning'].indexOf(this.currentDocument.state) > -1)
         || (this.currentDocument.state=='error_validating_moves' && this.currentDocument.errorJson && this.currentDocument.errorJson.user_error))
        )
        return true
      if(this.currentDocument && this.currentDocument.state=='error_not_supported_operation' && this.currentDocument.error && this.currentDocument.error.length > 0)
        return true
      if(
        this.currentDocument && this.currentDocument.state=='error_checking_taxes' && this.currentDocument.error && this.currentDocument.error.length > 0 &&
        this.currentDocument.error.startsWith('No es posible contabilizar')
      )
        return true
      return false 
    },
    goMirrorDocument() {
      if ((this.userData.is_staff || (this.userData.hasOwnProperty('username') && this.session_information.hasOwnProperty('username') && (this.session_information.username != this.userData.username)))) {
        let session_username = '';
        if (this.session_information.hasOwnProperty('username')) {
          session_username = this.session_information.username;
        }
        this.getMirrorDocument({ 'doc_id': this.currentDocument.id, 'session_username': session_username }).then(resp => {
          if (!resp.data.hasOwnProperty('ko')) {
            if (resp.data.hasOwnProperty('loginas')) {
              this.setLoginas(resp.data['loginas']).then(() => {
                this.$router.push({ 'name': 'document-detail', 'params': { 'companydb_id': resp.data['cdb_id'], 'document': resp.data['mirror_doc'] }}, () => {
                  this.$router.go();
                });
              });
            } else {
              let params = {
                'logged_username': this.session_information.username,
                'loginas_username': this.userData.username,
              };
              this.unsetLoginas(params).then(() => { 
                this.$router.push({ 'name': 'document-detail', 'params': { 'companydb_id': resp.data['cdb_id'], 'document': resp.data['mirror_doc'] }}, () => {
                  this.$router.go();
                });    
              });
            }
          }
        });
      }
    },
    changeDoc(cdb_id, doc_id) {
      let params = { 'companydb_id': cdb_id, 'document': doc_id }
      this.$router.push({ 'name': 'document-detail', 'params': params}, () => {
        this.$router.go();
      });
    },
    goSimulatedMirrorDocument() {
      if ((this.userData.is_staff || (this.userData.hasOwnProperty('username') && this.session_information.hasOwnProperty('username') && (this.session_information.username != this.userData.username)))) {
        let session_username = '';
        if (this.session_information.hasOwnProperty('username')) {
          session_username = this.session_information.username;
        }
        if (this.userData.can_see_training_documents) {
          this.getSimulationsFromTrainingDocument({ 'doc_id': this.currentDocument.id, 'session_username': session_username }).then(resp => {
            if (!resp.data.hasOwnProperty('ko')) {
              this.go_simulation_dialog = true;
              this.simulations = resp.data['simulated_mirror_docs'];
            }
          });
        } else {
          this.getSimulatedMirrorDocument({ 'doc_id': this.currentDocument.id, 'session_username': session_username }).then(resp => {
            if (!resp.data.hasOwnProperty('ko')) {
              this.changeDoc(resp.data['cdb_id'], resp.data['simulated_mirror_doc']);
            }
          });
        }
      }
    },
    goToSimulation(cdb_id, doc_id) {
      this.changeTrainerMode().then(() => {
        this.changeDoc(cdb_id, doc_id);
      })
    },
    go(action) {
      if (action == 'rotate_doc') {
        this.toggleRotationMode();
      } else if (action == 'split_doc') {
        this.splitDocument([ this.currentDocument, ]).then(() => {
          this.$router.replace({ name: 'document-list', params: { 'companydb_id': this.currentCompany.id } });
        }).catch(err => {
          this.message='Algo ha ido mal';
          this.show_message=true;
          console.error(err);
        });
      } else if (action == 'change_company_doc') {
        this.changeCompanyDocDialog = true;
      } else if (action == 'simulate_doc') {
        this.simulateDocDialog = true;
      } else if (action == 'add_tags_doc') {
        this.addTagsDocDialog = true;
      } else if (action == 'create_training_doc') {
        this.createTrainingDocDialog = true;
      } else if (action == 'check_document_history') {
        this.historyPopup = true;
      } else if (action == 'mark_as_pending_review') {
        this.markDocsAsPendingReview({ 'send_filters': false, 'docs': [ this.currentDocument.id, ]}).then(()=>{
          setTimeout(()=>this.start_check_async_job_state(this.currentDocument.id),3000)
        }).catch(err=>{
          this.message='Algo ha ido mal';
          this.show_message=true;
          console.error(err)
        });
      } else if (action == 'force_docs_state_to_done') {
        this.forceDocsStateToDone({ 'send_filters': false, 'docs': [ this.currentDocument.id, ]}).then(()=>{
          setTimeout(()=>this.start_check_async_job_state(this.currentDocument.id), 3000)
        }).catch(err=>{
          this.message='Algo ha ido mal';
          this.show_message=true;
          console.error(err)
        });
      } else if (action == 'force_send_invoice'){
        this.forceDocsSendInvoice({ 'send_filters': false, 'docs': [ this.currentDocument.id, ]}).then(()=>{
          setTimeout(()=>this.start_check_async_job_state(this.currentDocument.id), 3000)
        }).catch(err=>{
          this.message='Algo ha ido mal';
          this.show_message=true;
          console.error(err)
        });
      } else if (action == 'copy_id'){
        this.copyToClipboard(this.currentDocument.id);
      } else if (action == "change_view"){
        this.cambiarVista();
      }
      this.menu = false;
    },



    async getCompanyActivityList() {
      let params = {
        'companydb_id': this.companyChangeCompany.id, 
        'feature_code': 'feature_actividad_selector', 
        'field_show': 'actividad'
      };
      this.listActividadChangeCompany =  await this.getCompanyActivities(params);
    },

    changeCompanyItem() {
      this.changeCompanyDocDialog = false;
      let doc_ids = [ this.currentDocument.id, ];
      let cdb_id = this.companyChangeCompany.id;
      let params = {'doc_ids': doc_ids, 'new_cdb_id': cdb_id, };
      if (this.companyChangeCompany && this.companyChangeCompany.companydb_type.params && this.companyChangeCompany.companydb_type.params.show && this.companyChangeCompany.companydb_type.params.show.includes('actividad') && !isNaN(this.actividadChangeCompany) && parseInt(Number(this.actividadChangeCompany)) == this.actividadChangeCompany && !isNaN(parseInt(this.actividadChangeCompany, 10))) {
        params['actividad'] = this.actividadChangeCompany;
      }
      client.post('change_company_doc/', params).then(response => {
        if ('ko' in response.data) {
          this.message=response.data['ko'];
          this.show_message=true;
        } else {
          this.$router.replace({ name: 'document-detail', params: { 'companydb_id': cdb_id, 'document': this.currentDocument.id } });
          this.$router.go();
        }
      }).catch(err=>{
        this.message='Algo ha ido mal';
        this.show_message=true;
        console.error(err);
      });
    },
    noChangeCompanyItem() {
      this.changeCompanyDocDialog = false;
      this.companyChangeCompany = null;
      this.actividadChangeCompany = null;
      this.listActividadChangeCompany = [];
    },
    addTagsItem() {
      this.addTagsDocDialog = false
      let doc_ids = [ this.currentDocument.id, ];
      let params = {'doc_ids': doc_ids, 'tags': this.tagsAddTags}
      client.post("add_tags_doc/" , params).then(response => {
        this.tagsAddTags = [];
      }).catch(err => {
        this.message='Algo ha ido mal';
        this.show_message=true;
        console.error(err);
      });
    },
    noAddTagsItem() {
      this.addTagsDocDialog = false;
      this.tagsAddTags = [];
    },
    trainingItem() {
      this.createTrainingDocDialog = false
      let doc_ids = [ this.currentDocument.id, ];
      let params = {'doc_ids': doc_ids, 'tags': this.tagsTraining }
      client.post("create_training_copies/" , params).then(response => {
        this.tagsTraining = [];
        this.document_has_mirror = true;
      }).catch(err => {
        this.message='Algo ha ido mal';
        this.show_message=true;
        console.error(err);
      });
    },
    noTrainingItem() {
      this.createTrainingDocDialog = false;
      this.tagsTraining = [];
    },



    simulateItem() {
      this.invalid_default_accounting_date = false;
      if(this.accounting_date_config=='configurated'){
        if(isValidDate(this.default_accounting_date)){
          let d_str_split = this.default_accounting_date.split('/')
          let d = new Date(d_str_split[1]+'/'+d_str_split[0]+'/'+d_str_split[2])
          this.default_accounting_date=this.date_to_string(d)
          this.document_has_simulated_mirror = true;
        }else{
          this.invalid_default_accounting_date = true;
        }
      }
      if (!this.invalid_default_accounting_date) {
        this.simulateDocDialog = false
        let doc_ids = [ this.currentDocument.id, ];
        let cdb_id = this.companySimulate.id;
        let params = {
          'doc_ids': doc_ids,
          'cdb_id': cdb_id,
          'tags': this.tagsSimulate,
          'accounting_date_config': this.accounting_date_config, 
          'default_accounting_date': this.default_accounting_date
        }
        client.post("create_simulation_copies/" , params).then(response => {
          if ('ko' in response.data) {
            this.message=response.data['ko'];
            this.show_message=true;
          } else {
            this.companySimulate = null;
            this.tagsSimulate = [];
            this.accounting_date_config = 'invoice_date';
            this.default_accounting_date = null;
          }
        }).catch(err => {
          this.message='Algo ha ido mal';
          this.show_message=true;
          console.error(err)
        });
      }
    },
    noSimulateItem() {
      this.simulateDocDialog = false;
      this.companySimulate = null;
      this.tagsSimulate = [];
      this.accounting_date_config = 'invoice_date';
      this.default_accounting_date = null;
    },
    date_to_string(d){
      var mm = d.getMonth() + 1;
      var dd = d.getDate();
      return [(dd>9 ? '' : '0') + dd, (mm>9 ? '' : '0') + mm, d.getFullYear()].join('/');
    },
    canSave() {
      const READONLY_STATES = [
        'pending_upload',
        'pending_connect',
        'accounting_aplifisa_fiscal',
        'accounting_invoice',
        'pending_sync',
        'done',
        'done_manually',
        'done_with_warning',
      ];
      return !(this.currentDocument && (this.isWaitingFlow || READONLY_STATES.includes(this.currentDocument.state)))
       || this.fixMotxo ;
    },
    setSearchAndRedirectToList() {
      this.setFiltersDataSearchDuplicateValue(this.metadata_inv_number)
      this.setDocumentKind(this.currentDocument.kind)
      this.$router.push({ name: 'document-list' })
      this.generateFilters()
    },
    showActivityField(companydb, field) {
      return companydb && companydb.companydb_type.params && companydb.companydb_type.params.show && companydb.companydb_type.params.show.includes(field)
    },

    forceSendDocument(){
      this.forceDocsSendInvoice({ 'send_filters': false, 'docs': [ this.currentDocument.id, ]}).then(()=>{
            setTimeout(()=>this.start_check_async_job_state(this.currentDocument.id), 3000)
          }).catch(err=>{
            this.message='Algo ha ido mal';
            this.show_message=true;
            console.error(err)
          });
    },
    async cambiarVista() {
      const idUser = this.userData["user"]
      const view = "new_view"
      let command_dispatcher = sync_command_dispatcher
      await command_dispatcher.dispatch('set.detail.invoice.view',
        {
          "user_id": idUser,
          "view": view
        }
      )
      window.location.reload();
    },
    async downloadFacturae(){
      
      let inv_id = this.currentDocument.id
      let filename =  this.getFileName.split('.')[0] + '.xml'
      await new CreateXMLFromInvoice(sync_command_dispatcher, this).run(inv_id,filename);





    //   let doc_ids = [ this.currentDocument.id, ];
    //   let params = {'doc_ids': doc_ids, 'tags': this.tagsTraining }
    //   // client.get("facturae/2236418" , params)
      
    //   client.get("facturae/"+this.currentDocument.id+"/download/" , params)
    //   .then(response => {
    //     let fileURL = window.URL.createObjectURL(new Blob([response.data]));
    //     let fileLink = document.createElement("a");
    
    //     fileLink.href = fileURL;
    //     fileLink.setAttribute("download", "facturae.xml");
    //     document.body.appendChild(fileLink);
    
    //     fileLink.click();
        
    //   }).catch(err => {
    //     this.message='Algo ha ido mal';
    //     this.show_message=true;
    //     console.error(err);
    //   });
      
     },
    copyToClipboard,

  },
};
</script>

<style scoped>
.selected-chevron {
  margin-right: 0.5em;
}
.primary-bckground {
  background-color: var(--v-primary-base);
}
.primary-border {
  border-color: var(--v-primary-base) !important;
}

.divisa {
  display: flex;
  align-items:baseline;
}

.under__text__divisa {
  padding-left: 25px;
  font-size: 0.9rem;
}
</style>
